import { Dispatch, SetStateAction } from "react";
import type { SkillTableRow } from "../../types/api";
import { Box, IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import usePermission from "../../hooks/usePermission";
import Pagination from "../../components/Panigation";
import useTranslation from "../../hooks/traslation";
import SkillDetails from "../../Modals/skillDetails";

type props = {
  open: boolean;
  openDelete: boolean;
  setOpenDelete: Dispatch<SetStateAction<boolean>>;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setSelectedId: Dispatch<SetStateAction<string>>;
  name: string;
  rows: SkillTableRow[];
  openDetails: boolean;
  setOpenDetails: Dispatch<SetStateAction<boolean>>;
  
  setName: Dispatch<SetStateAction<string>>;
  isLoading: boolean;
  handleEditClick: (row: SkillTableRow) => void;
  setRows: Dispatch<SetStateAction<SkillTableRow[]>>;
  handlePageChange: (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => void;
  setPage: Dispatch<SetStateAction<number>>;
  page: number;
  totalCount: number;
  setNameAr: Dispatch<SetStateAction<string>>;
};

const SkillsList = ({
  setOpen,
  setOpenDetails,
  setSelectedId,
  setName,
  setOpenDelete,
  rows,
  isLoading,
  handleEditClick,
  totalCount,
  handlePageChange,
  page,
  setPage,
  setNameAr,
}: props) => {
  const translate = useTranslation();

  const { isAdd, isDelete } = usePermission({
    label: "Manage Skills",
    page_permission: "isView",
  });

  const itemsPerPage = 10;
  let totalPages = Math.ceil(totalCount / itemsPerPage);

  return (
    <>
      <div className="sorting_table">
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th>{translate?.globals?.name || "Name"} {translate?.main?.english || "English"}</th>
              <th>{translate?.globals?.name || "Name"} {translate?.main?.arabic || "Arabic"}</th>
              <th>{translate?.main?.createdAt || "Created At"}</th>
              <th>{translate?.globals?.actions || "Actions"}</th>
            </tr>
          </thead>
          <tbody>
            {rows?.length ? (
              rows?.map((row: SkillTableRow) => (
                <tr key={row._id}>
                  <td>{row?.name || ""}</td>
                  <td>{row?.name_ar || ""}</td>
                  <td>
                    {moment(row?.createdAt).format("DD MMM YYYY")}
                  </td>
                  <td>
                    <div className="table_actions v2">
                      <div className="table_actions v2">
                        <Box>
                          <Tooltip title="View">
                            <IconButton
                              onClick={() => {
                                setOpenDetails(true);
                                setSelectedId(row?._id);
                                setName(row?.name ?? "");
                                setNameAr(row?.name_ar || "");
                              }}
                            >
                              <img
                                src="/static/images/eye_icon.svg"
                                alt=""
                              />
                            </IconButton>
                          </Tooltip>
                        </Box>
                        {isAdd ? (
                          <Box>
                            <Tooltip title="Edit">
                              <IconButton
                                onClick={() => {
                                  handleEditClick(row);
                                }}
                              >
                                <img
                                  src="/static/images/edit2_icon.svg"
                                  alt=""
                                />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        ) : null}

                        {isDelete ? (
                          <Box>
                            <Tooltip title="Delete">
                              <IconButton
                                onClick={() => {
                                  setSelectedId(row?._id);
                                  setOpenDelete(true);
                                }}
                              >
                                <img
                                  src="/static/images/trash2_icon.svg"
                                  alt=""
                                />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        ) : null}
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={4}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  {translate?.auth?.noDataFound || "No data found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {totalCount > 0 ? (
          <Pagination
            setPage={setPage}
            module={rows}
            page={page}
            onPageChange={(newPage: number) => {
              setPage(newPage);
            }}
            totalPages={totalPages}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default SkillsList;
